var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-easy-lightbox',{attrs:{"scrollDisabled":"","escDisabled":"","moveDisabled":"","visible":_vm.visible,"imgs":_vm.img},on:{"hide":_vm.handleHide}})}
var staticRenderFns = []

export { render, staticRenderFns }